<template>
  <div :class="{ 'wrapper': wrapper}">
    <div class="navbar-drawer" :class="{ 'is-active': expanded, 'navbar-drawer-left': isLeft && isDesktop && minScreenWidth, 'navbar-drawer-right': isRight && isDesktop, 'navbar-drawer-right-full': isFull && isDesktop}">
      <slot>
        <!-- Drawer content -->
      </slot>
      <div class="navbar-drawer__close text-center" @click.prevent="closeAll">
        Close <span class="navbar-drawer__close--icon" />
      </div>
    </div>
  </div>
</template>

<script>

import closeTab from '../../../mixins/closeTab';

export default {
  mixins: [closeTab],
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
    wrapper: {
      type: Boolean,
      default: false,
    },
    pos: {
      type: String,
    },
  },
  computed: {
    isFull() {
      return this.pos === 'full';
    },
    isLeft() {
      return this.pos === 'left';
    },
    isRight() {
      return this.pos === 'right';
    },
    isDesktop() {
      return this.$store.getters['common/getScreenType'] === 'desktop';
    },
    minScreenWidth() {
      return document.querySelector('body').offsetWidth >= 1279;
    },
  },
  methods: {
    closeAll() {
      // this allows datepicker to close too for propergation
      this.closeTab();
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/styles/settings/config.scss";

.navbar-drawer {
  position: absolute;
  display: block;
  width: 100%;
  background-color: $stoneWhite;
  color: $plum;
  // overflow-x: hidden;
  // overflow-y: auto;
  @include dropdown(-4px);

  // for huw's odd short screen
 @media only screen and (min-width: 768px) and (max-height: 600px) {
    height: 420px;
    overflow-y: scroll;
  }

  &-algolia > .is-active {
// IPHONE AND TABLET LANDSCAPE
    @media only screen and (min-device-width: 768px) and (max-device-width: 1023px) and (orientation: landscape) {
      height: 500px;
    }

    @media only screen and (min-device-width: 1024px) and (orientation: landscape) {
      min-height: 200px;
      max-height: 580px;
    }

    // IPHONE PORTRAIT
    @media (max-width: 480px) and (orientation: portrait)  {
      height: 625px;
    }

    // TABLET PORTRAIT
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
      height: 900px;
    }

     @media (max-width: 900px) {
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  }

  &__close {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0.5em 0 2em;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.7px;
    cursor: pointer;
    &:hover {
      cursor: pointer;
    }
    &--icon {
      background-image: svg-load("icons/close-x.svg");
      background-size: contain;
      width: 12px;
      height: 12px;
      margin-left: 5px;
    }
  }
}

// SHARED STYLES FOR DRAWER SLOT
.navtab {
  font-size: 14px;
  min-height: 390px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  min-height: 400px;
  @media (max-width: 768px) {
    max-width: 100%;
    overflow: hidden;
  }
  &__box {
    border: 1px solid $stoneCream;
    padding: 2em;
    &--title {
      text-transform: uppercase;
      font-weight: 500;
      margin-bottom: 2em;
    }
    &--list {
      cursor: pointer;
      display: inline-block;
      // to keep bottom border from jumping
      border-bottom: 1px solid transparent;
      padding-bottom: 1px;
      margin-bottom: 12px;
      &:hover {
        border-bottom: 1px solid $darkBlack;
      }
      &.active {
        border-bottom: 1px solid $darkBlack;
      }
    }
    &--sublist {
      border-bottom: 1px solid transparent;
      padding-bottom: 1px;
      margin-bottom: 8px;
      &_link {
        &:hover {
          border-bottom: 1px solid $darkBlack;
        }
      }
      &_link {
        color: $plum;
      }
    }
    &.image {
      @media (max-width: 1200px) {
        display: none;
      }
    }
  }
}

@include desktop {
  .navbar-drawer {
    &-full {
      width: 100%;
      left: 0;
    }
  }
}

@media (min-width: 1279px) {
  .navbar-drawer {
    &-left {
      width: 50%;
      left: 0;
      min-width: 958px;
    }
    &-right {
      width: 50%;
      right: 0;
    }
  }
}

</style>
